/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AccessIdPhoto200,
  GetApiV1AccessIdPhoto401,
  GetApiV1AccessIdPhoto404,
  GetApiV1AccessIdPhoto500,
  GetApiV1AccessIdPhotoPathParams,
  GetApiV1AccessIdPhotoQueryResponse,
} from "../../types/personRegisterController/GetApiV1AccessIdPhoto.ts";

export const getApiV1AccessIdPhotoPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1AccessIdPhotoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AccessIdPhoto200Schema =
  z.any() as unknown as ToZod<GetApiV1AccessIdPhoto200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AccessIdPhoto401Schema =
  z.any() as unknown as ToZod<GetApiV1AccessIdPhoto401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1AccessIdPhoto404Schema =
  z.any() as unknown as ToZod<GetApiV1AccessIdPhoto404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AccessIdPhoto500Schema =
  z.any() as unknown as ToZod<GetApiV1AccessIdPhoto500>;

export const getApiV1AccessIdPhotoQueryResponseSchema = z.lazy(
  () => getApiV1AccessIdPhoto200Schema,
) as unknown as ToZod<GetApiV1AccessIdPhotoQueryResponse>;
